<template>
    <div class="w-view-shell">
        <div class="crumbs-shell">
            当前位置：消息详情
        </div>
        <div class="information-content">
            <div class="information-detail-shell">
                <div class="information-title">{{article_detail.news_title}}</div>
                <div class="information-html" v-html="article_detail.news_content"></div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'detailss',
    data () {
      return {
        news_id: '',
        article_detail: '',
        hot_page: 1,
        hot_list: [],
        siftt_page: 1,
        sift_list: []
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      if (this.$route.query.news_id) {
        this.news_id = this.$route.query.news_id
        this.get_detail()
      }
    },
    methods: {
      get_detail () {
        this.API.post('Home/article_out-get_news_detail', {
          news_id: this.news_id
        }).then((res) => {
          this.article_detail = res.data.news_detail
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .w-view-shell {
        width: 1200px;

        .crumbs-shell {
            display: flex;
            align-items: center;
            height: 101px;
        }

        .information-content {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            .information-detail-shell {
                width: 1200px;
                min-height: 50vh;
                background-color: #fff;
                margin-bottom: 20px;

                .information-title {
                    margin: 40px 30px;
                    font-size: 38px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }

                .news-img {
                    padding: 0 30px;
                    margin-bottom: 38px;
                }

                .information-html {
                    padding: 0 30px;
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    line-height: 30px;
                    padding-bottom: 65px;
                }
            }

            .sift-shell {
                width: 420px;
                background-color: #fff;
                padding: 0 25px;

                .sift-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 101px;
                    font-size: 30px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                }

                .sift-list {
                    border-top: 1px solid #E5E5E5;
                    padding-top: 40px;

                    .sift-box {
                        margin-bottom: 46px;

                        .news-img {
                            width: 370px;

                            img {
                                width: 100%;
                            }
                        }

                        .news-name {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #000000;
                            margin: 18px 0 10px;
                        }

                        .news-desc {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #999999;
                            line-height: 36px;
                        }
                    }
                }
            }
        }

        .hot-shell {
            width: 100%;
            border-top: 1px solid #E5E5E5;
            margin-top: 28px;

            .hot-title {
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #18949C;
                margin: 33px 0 39px;
                position: relative;
                text-indent: 24px;

                &:after {
                    position: absolute;
                    content: "";
                    left: 0px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 9px;
                    height: 22px;
                    background: #18949C;
                }
            }

            .hot-list {
                display: flex;
                margin-bottom: 90px;

                .hot-box {
                    width: 320px;
                    margin-right: 100px;

                    .news-img {
                        width: 320px;
                        margin-bottom: 32px;

                        img {
                            width: 100%;
                        }
                    }

                    .news-name {
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000000;
                        margin-bottom: 22px;
                    }

                    .news-desc {
                        width: 320px;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
        }
    }
</style>
